import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.token);
      toast.success(`Welcome, ${data.name}`);
      nav("/admin");
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <main data-testid="admin-login-page" className="min-h-[80vh] flex items-center">
      <div className="max-w-md mx-auto w-full px-6 py-16">
        <div className="border border-stone-200 bg-white p-8 sm:p-10">
          <div className="w-10 h-10 rounded-md bg-emerald-900 text-stone-50 flex items-center justify-center">
            <Lock size={18} />
          </div>
          <div className="eyebrow mt-6">Admin</div>
          <h1 className="mt-2 font-heading text-3xl text-stone-900">Sign in to dashboard</h1>
          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="admin-login-form">
            <label className="block">
              <span className="eyebrow">Email</span>
              <input type="email" required data-testid="admin-email" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-2 w-full border border-stone-200 focus:border-emerald-900 outline-none px-3 py-2.5 bg-white" />
            </label>
            <label className="block">
              <span className="eyebrow">Password</span>
              <input type="password" required data-testid="admin-password" value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-2 w-full border border-stone-200 focus:border-emerald-900 outline-none px-3 py-2.5 bg-white" />
            </label>
            <button disabled={busy} data-testid="admin-login-submit" className="w-full inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-emerald-900 text-stone-50 hover:bg-emerald-950 disabled:opacity-60 transition-colors duration-200">
              {busy ? <><Loader2 className="animate-spin" size={16} /> Signing in...</> : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
